export enum AgreementStatus {
    UNKNOWN = 'UNKNOWN',
    DECLINED = 'DECLINED',
    CONSENTED = 'CONSENTED'
}